import { render } from "./NotFound.vue?vue&type=template&id=5f9ad06e"
const script = {}
script.render = render

export default script